export function getFuncOnlyExecuteOnlyOnce (func) {
  let isExecuted = false
  return function (param) {
    if (!isExecuted) {
      isExecuted = !isExecuted
      func(param)
    }
  }
}
export function arrayIsEqual (a, b) {
  return JSON.stringify(a.sort()) === JSON.stringify(b.sort())
}
